import { withTheme, keyframes, css } from '@emotion/react';
import { NavLink } from "react-router-dom";
import { withRouter } from "../helpers/withRouter";
import { useInView } from 'react-intersection-observer';
import styled from '@emotion/styled';
import EnergyTop1 from '../assets/images/design_elements/energy-arc-top.svg';
import EnergyBottom1 from '../assets/images/design_elements/energy-arc-bottom.svg';
import BasicTextBlock from './shared/BasicTextBlock';

const topIn = keyframes`
  0%, 50% {
    transform: rotate(-180deg) translateX(-100%);
  }
  65% {
    opacity: 0;
  }
  100% {
    opacity: 1;
    transform: rotate(0deg) translateX(5%);
  }
`;

const bottomIn = keyframes`
  0%, 50% {
    transform: rotate(-180deg) translateX(100%);
  }
  65% {
    opacity: 0;
  }
  100% {
    opacity: 1;
    transform: rotate(0deg) translateX(5%);
  }
`;

const BlockWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 60px 0;
  position: relative;

  @media (min-width: ${props => props.theme.breakpoints.sm}) {
    padding: 110px 0 90px;
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    padding: 90px 0 110px;
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    padding: 100px 0 120px;
  }
`;

const AnimationWrapper = styled.div`
  ${props => props.simplified && css`
    display: none;
  `}
  height: 90px;
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 150%;
  transform: rotate(10deg);
  margin-left: 10%;
  z-index: -1;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    width: 90%;
    transform: rotate(0deg);
    max-width: 330px;
    margin-left: 0;
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    height: 120px;
  }
`;

const AnimationWrapperBottom = styled.div`
  ${props => props.simplified && css`
    display: none;
  `}
  height: 90px;
  overflow: hidden;
  position: absolute;
  bottom: 0px;
  width: 150%;
  transform: rotate(-9deg);
  z-index: -1;
  margin-left: 30%;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    width: 90%;
    max-width: 330px;
    transform: rotate(0deg);
    margin-left: 0;
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    height: 120px;
  }
`;

const AnimationTop = styled.div`
  ${props => props.inView && css`
    animation-name: ${topIn};
    animation-duration: 1s;
    animation-fill-mode: forwards;
  `}
  animation-timing-function: ease;
  background-image: url(${EnergyTop1});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 90px;
  opacity: 0;
  position: absolute;
  top: 0px;
  transform: rotate(-180deg) translateX(-100%);
  transform-origin: center bottom;
  width: 90%;

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    height: 120px;
  }
`;

const AnimationBottom = styled.div`
  ${props => props.inView && css`
    animation-name: ${bottomIn};
    animation-duration: 1s;
    animation-fill-mode: forwards;
  `}
  animation-timing-function: ease;
  background-image: url(${EnergyBottom1});
  background-repeat: no-repeat;
  background-size: contain;
  bottom: 0px;
  height: 90px;
  position: absolute;
  transform: rotate(180deg) translateX(100%);
  transform-origin: center top;
  width: 90%;

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    height: 120px;
  }
`;

const ContentWrapper = styled.div`
  background: ${props => props.theme.colors.neutral2};
  margin: 0 ${props => props.theme.margins.xs};
  max-width: 600px;
  padding: 0 ${props => props.theme.margins.xs};
`;

const SubLink = styled(NavLink)`
  color: ${props => props.theme.colors.primary1};
  font-family: ${props => props.theme.fonts.secondary};
  display: inline-block;
  margin-bottom: ${props => props.theme.margins.xs};
  text-decoration: none;
  width: 100%;
  text-align: right;

  &:hover {
    color: ${props => props.theme.colors.secondary4};
  }

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    text-align: left;
  }
`;


function BlockCTA(props) {
  const { textBlockData, ctaLink: { url, text } } = props.data;
  const { ref, inView } = useInView({
    threshold: .1,
  });

  return (
    <BlockWrapper ref={ref}>
      <AnimationWrapper>
        <AnimationTop inView={inView} />
      </AnimationWrapper>
      <ContentWrapper>
        <BasicTextBlock headerColor="primary4" textAlign="left" textBlockData={textBlockData} />
        <SubLink to={url}>{`${text} →`}</SubLink>
      </ContentWrapper>
      <AnimationWrapperBottom>
        <AnimationBottom inView={inView} />
      </AnimationWrapperBottom>
    </BlockWrapper>
  )
}

export default withRouter(withTheme(BlockCTA));